var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-expediente-contrato"}},[_c('expediente',{attrs:{"idReferencia":_vm.idReferencia,"soloLectura":_vm.soloLectura,"moduloExpedienteOrigen":"contratos"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }